<div [formGroup]="parentFormGroup" class="form-container">
  <!--
  <p>Select a timezone</p>
  <timezone-picker datetime="2018-08-23T10:00" timezone="Europe/London" (update)="updateTimezone($event)"></timezone-picker>
  -->
  <mat-form-field appearance="outline">
    <mat-label i18n>Timezone</mat-label>
    <input matInput [matAutocomplete]="timezone" id="booking-date-timezone" formControlName="timezone" required>
    <mat-autocomplete requireSelection #timezone="matAutocomplete">
      <mat-option *ngFor="let option of filteredTzNames | async" [value]="option.id">
        {{ option.name }}
      </mat-option>
    </mat-autocomplete>
    <mat-error *ngIf="getFormControl().errors && getFormControl().errors.timezoneValidator" i18n>
      The timezone selected is not correct
    </mat-error>
  </mat-form-field>
</div>
